import * as yup from 'yup';
import FormFieldType from 'src/shared/ui/components/Form/FormFieldFactory/FormFieldType';

const canShowCompanyHeadquarterField = (userHeadquarterList, fields) => {
  if (!fields || !fields.companyHeadquarterListId) {
    return true;
  }

  return fields.companyHeadquarterListId.every((companyHeadquarterId) => {
    return userHeadquarterList
      .map((x) => x.CompanyHeadquarter.id)
      .includes(companyHeadquarterId);
  });
};

const ContractType = ({
  fields,
  companyServiceList,
  companyProductList,
  contractTypeList,
  userHeadquarterList,
  selectedUserHeadquarter
}) => [
  {
    name: 'companyHeadquarterListId',
    validation: yup
      .array()
      .of(yup.string())
      .nullable(false),
    type: FormFieldType.SELECT_CHIP,
    value:
      fields && fields.companyHeadquarterListId
        ? fields.companyHeadquarterListId
        : [selectedUserHeadquarter],
    options: userHeadquarterList.map((x) => {
      return { id: x.CompanyHeadquarter.id, name: x.CompanyHeadquarter.name };
    }),
    fullWidth: true,
    enabled: canShowCompanyHeadquarterField(userHeadquarterList, fields)
  },
  {
    name: 'name',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.name ? fields.name : '',
    fullWidth: true
  },
  {
    name: 'contractCodePrefix',
    validation: yup.string().required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.contractCodePrefix ? fields.contractCodePrefix : ''
  },
  {
    name: 'totalDuration',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.totalDuration ? fields.totalDuration : '0'
  },
  {
    name: 'price',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.price ? fields.price : '0'
  },
  {
    name: 'promoDuration',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.promoDuration ? fields.promoDuration : '0'
  },
  {
    name: 'discountPercentage',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.discountPercentage ? fields.discountPercentage : '0'
  },
  {
    name: 'installationCost',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.installationCost ? fields.installationCost : '0'
  },
  {
    name: 'installationTerms',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.installationTerms ? fields.installationTerms : '0'
  },
  {
    name: 'sellerComission',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.sellerComission ? fields.sellerComission : '0'
  },
  {
    name: 'unmanagedSignaturePenaltyFee',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value:
      fields && fields.unmanagedSignaturePenaltyFee
        ? fields.unmanagedSignaturePenaltyFee
        : '0'
  },
  {
    name: 'referralComission',
    validation: yup
      .number()
      .typeError('fieldNumeric')
      .nullable(true)
      .required('fieldRequired'),
    type: FormFieldType.TEXT_FIELD,
    value: fields && fields.referralComission ? fields.referralComission : '0'
  },
  {
    name: 'contractTypeIdAfterExpiration',
    validation: yup.string().nullable(true),
    type: FormFieldType.SELECT,
    value:
      fields && fields.contractTypeIdAfterExpiration
        ? fields.contractTypeIdAfterExpiration
        : '',
    options: contractTypeList
      .map((x) => {
        return { id: x.id, name: x.name };
      })
      .concat({ id: '', name: '-' }),
    fullWidth: true
  },
  {
    name: 'nextBillPeriod',
    validation: yup.boolean(),
    type: FormFieldType.CHECKBOX,
    value:
      fields && fields.nextBillPeriod != null ? fields.nextBillPeriod : false
  },
  {
    name: 'prepayment',
    validation: yup.boolean(),
    type: FormFieldType.CHECKBOX,
    value: fields && fields.prepayment != null ? fields.prepayment : false
  },
  {
    name: 'serviceList',
    validation: yup.array().of(yup.string()),
    type: FormFieldType.SELECT_CHIP,
    value: fields && fields.serviceList ? fields.serviceList : [],
    options: companyServiceList,
    fullWidth: true
  },
  {
    name: 'productList',
    validation: yup.array().of(yup.string()),
    type: FormFieldType.SELECT_CHIP,
    value: fields && fields.productList ? fields.productList : [],
    options: companyProductList,
    fullWidth: true
  }
];

export default ContractType;
